import {field} from "../../../stem-core/state/StoreField.js";
import {Merchant} from "../MerchantStore";
import {MerchantFees} from "./MerchantFeesStore";
import {MerchantStaff} from "./MerchantStaffStore";
import {MerchantRevenue} from "./MerchantRevenueStore";
import {apiClient} from "../../connection/BlinkApiClient.js";
import type {StoreId} from "../../../stem-core/state/State";
import {UserProfile} from "../UserProfileStore";
import {GlobalState} from "../../../stem-core/state/State";

export class AdminMerchant extends Merchant {
    @field("UserProfile") user: UserProfile;         // The owner
    @field(String) cardStatementName: string;

    getFees(): MerchantFees | null {
        return MerchantFees.find(item => item.merchantId === this.id);
    }

    getUsersAccess(): MerchantStaff[] {
        return MerchantStaff.filter(item => item.merchantId === this.id);
    }

    getRevenue(): MerchantRevenue | undefined {
        return MerchantRevenue.get(this.id);
    }
}

export async function apiAdminFetchMerchant(merchantId: string): Promise<Merchant> {
    await apiClient.get("admin/merchants/merchant_data/", {merchantId});
    return Merchant.get(merchantId);
}

// AdminUpdateMerchantRequest (api/admin_api/views/merchants.py)
export interface AdminUpdateMerchantRequest {
    merchantId: StoreId;
    name?: string;
    alias?: string;
    url?: string;
    wideLogoUrl?: string;
    cardStatementName?: string;
    isFake?: boolean;
    autoPay?: boolean;
    allowPurchases?: boolean;
    allowSubscriptions?: boolean;
    allowDonations?: boolean;
}

export async function apiUpdateMerchant(data: AdminUpdateMerchantRequest): Promise<any> {
    return apiClient.post("admin/merchants/update_merchant/", data);
}

// TODO @types Overwrite the base object
GlobalState.stores.set("merchant", AdminMerchant);
